import evaluateExpression from "@/helpers/evaluateExpression";

const evaluateListFilter = (item: Record<string, unknown>, expression: string, checkfield: string): boolean => {
  if (!expression) {
    return true;
  }

  const result = evaluateExpression({
    expression,
    id: 'HandleAIAgent-evaluateListFilter',
    variables: { [checkfield]: item[checkfield] },
  });
  return Boolean(result);
};

export default evaluateListFilter;